import { useEffect, useState } from 'react'

import DashboardTopBar from './DashboardTopBar'
import DashboardStageHistory from './DashboardScreens/DashboardStageHistory'
import DashboardSidePanel from './DashboardSidePanel'
import DashboardHeader from './DashboardHeader'
import DashboardDocumentsCenter from './DashboardScreens/DashboardDocumentCenter/DashboardDocumentsCenter'
import DashboardResourceCenter from './DashboardScreens/DashboardResourceCenter'
import DashboardQA from './DashboardScreens/DashboardQA'
import DashboardContactUs from './DashboardScreens/DashboardContactUs'
import {
  refreshAccessToken, shouldShowChartConnect, shouldShowChartInstantCalculation, shouldShowDocuments, shouldShowPostPaidDiscount, shouldShowDealCompletePartialPayInvoice, shouldShowPayInvoiceButton, isDocumentsAvailablePrepaidStage,
  shouldShowTaxStatusToChart, showCollectionsWindow, showPendingCalcWindow, showRefundCalculatedWindow,
  shouldShowPaymentInstallmentTile, shouldShowPaymentInstallmentStatus, shouldShowPostpaidStyleReauthorizeFlow, shouldShowUpdateCardOnFileTile
} from '../../utilities/extensions'
import DashboardDocumentsHeader from './DashboardScreens/DashboardDocumentsHeader'
import { company, customerData } from '../../utilities/CustomerData'
import { RefundCalculatedWindow } from '../Payment/RefundCalculatedWindow'
import { useLocation, useNavigate } from 'react-router-dom'
import DashboardReferAFriend from './DashboardScreens/DashboardReferAFriend'
import DashboardChangeDays from './DashboardScreens/DashboardChangeDays'
import MobileSideBar from '../../utilities/MobileSideBar'
import { DashboardDiscountCode } from './DashboardScreens/DashboardDiscountCode'
import { WelcomeModal } from '../WelcomeModal'
import { CollectionsWindow } from './DashboardScreens/CollectionsWindow'
import { DashboardChartConnect } from './DashboardScreens/DashboardChartConnect'
import { DashboardChartInstantCalculation } from './DashboardScreens/DashboardChartInstantCalculation'
import { DashboardResetAgreement } from './DashboardResetAgreement'
import { DashboardReconnectChart } from './DashboardScreens/DashboardReconnectChart'
import { apiURL } from '../../utilities/URLs'
import { DashboardFailedBankValidation } from './DashboardScreens/DashboardFailedBankValidation'
import { DashboardBankVerified } from './DashboardScreens/DasboardBankVerified'
import { DashboardESign } from './DashboardScreens/DashboardESign'
import { DashboardIssueWithDocs } from './DashboardScreens/DashboardIssueWithDocs'
import { DashboardResyncIDME } from './DashboardScreens/DashboardResyncIDME'
import { DashboardInstantOffline } from './DashboardScreens/DashboardInstantOffline'
import { DashboardPendingBank } from './DashboardScreens/DashboardPendingBank'
import { DashboardResign } from './DashboardScreens/DashboardResign'
import { DashboardSignAffidavit } from './DashboardScreens/DashboardSignAffidavit'
import { DashboardPendingCals } from './DashboardScreens/DashboardPendingCalcs'
import { DashboardDocsSentToOffice } from './DashboardScreens/DasboardDocsSentToOffice'
import { DashboardInReview } from './DashboardScreens/DashboardInReview'
import { DashboardDocsSentToIRS } from './DashboardScreens/DashboardDocsSentToIRS'
import { DashboardDocsReceivedAtIRS } from './DashboardScreens/DashboardDocsReceivedAtIRS'
import { DashboardSyncBankAccount } from './DashboardScreens/DashboardSyncNewBankAccount'
import DashboardUpdateBanking from './DashboardScreens/DashboardUpdateBanking'
import DashboardCompleteIDme from './DashboardScreens/DashboardCompleteIDMe'
import DashboardSignTOS from './DashboardScreens/DashboardSignTOS'
import DashboardProgress from './DashboardScreens/DashboardProgress'

import DashboardPastDeadline from './DashboardScreens/DashboardPastDeadline'
import DashboardManualIDReview from './DashboardScreens/DashboardManaulIDReview'
import DashboardUploadReviewID from './DashboardScreens/DashboardUploadReviewID'
import { DateTime } from 'luxon'
import DashboardMissplacedCheck from './DashboardScreens/DashboardMissplacedCheck'
import Send8822 from './DashboardScreens/Send8822'
import DashboardReauthFlow from './DashboardScreens/DashboardReauthFlow'
import { DashboardDemandLetter } from './DashboardScreens/DashboardDemandLetter'
import DashboardPaymentInstallments from './DashboardScreens/DashboardPaymentInstallments'

const REAUTH_TURNKEY_STAGE_ID = 'a1b2c3d4-3333-4aaa-bbbb-reauth0003tk'

export default function Dashboard({ showMobileSideBar, setShowMobileSideBar, setShowNavBar, setCheckForCalculation }) {
  const navigate = useNavigate()
  const location = useLocation()
  const currentActiveTab = location.state ? location.state.activeTab : 0

  const [activeTab, setActiveTab] = useState(-1)
  const [canInstantCalc, setCanInstantCalc] = useState(false)
  const [canAF, setCanAF] = useState(true)
  const [checkedInstantCalc, setCheckedInstantCalc] = useState(false)
  const [isPreQualified, setIsPreQualified] = useState(shouldShowChartConnect())
  const [isTaxStatus, setIsTaxStatus] = useState(shouldShowTaxStatusToChart(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isChartInstantCalc, setIsChartInstantCalc] = useState(shouldShowChartInstantCalculation(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [hasDocuments, setHasDocuments] = useState(shouldShowDocuments(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isPendingCalc, setIsPendingCalc] = useState(showPendingCalcWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [hasRefund, setHasRefund] = useState(showRefundCalculatedWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isCollections, setIsCollections] = useState(showCollectionsWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [resetAgreement, setResetAgreement] = useState(customerData.customerPlaidAgreement.resetAgreement)
  const [invalid8821, setInvalid821] = useState(customerData.customerLeadData.leadContact.chartStatus === 'REJECTED' || customerData.customerLeadData.leadStage?.leadStageId === 'f694c99f-93d8-450b-a947-0acb7c7ac4b3')
  const [failedBankValidation, setFailedBankValidattion] = useState(customerData.customerLeadData.leadStage?.leadStageId === '715b25ed-9768-4a95-8e42-0d8fe4076fa1')
  const [failedToCreateBankApplication, setFailedToCreateBankApplication] = useState(customerData.customerLeadData.leadStage?.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91')
  const [bankValidated, setBankValidated] = useState(customerData.customerLeadData.leadStage?.leadStageId === '515d1c17-d315-4e32-ac0f-f3aeb38e7080')
  const [issueWithDocs, setIssueWithDocs] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'c0dc31c8-10be-4dc0-9796-a80ca8b4bbb4')
  const [canESign, setCanESign] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'c82cc1f9-a5a1-46d5-bd05-23dad9a4878b')
  const [isPendingBank, setIsPendingBank] = useState(customerData.customerLeadData.leadStage?.leadStageId === '5eed0588-1ae4-4690-8af9-e5aaf2fe97e5')
  const [docsMailed, setDocsMailed] = useState(customerData.customerLeadData.leadStage?.leadStageId === '89073790-fb45-4e58-adfe-20c7cb6c0e17')
  const [docsReceived, setDocsReceived] = useState(customerData.customerLeadData.leadStage?.leadStageId === '0a0c959f-7286-4f8f-97c3-20b8e8b873cd')
  const [resign, setResign] = useState(customerData.customerLeadData.leadStage?.leadStageId === '34eaa794-f482-4112-9bf8-1f37d2029128')
  const [signAffidavit, setSignAffidavit] = useState(customerData.customerLeadData.leadStage?.leadStageId === '4aa5f65b-4474-4d2e-9a0c-f84bd305aff6')
  const [showWelcomeModal, setShowWelcomeModal] = useState(false)
  const [inReview, setInReview] = useState(customerData.customerLeadData.leadStage?.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91')
  const [docsSentToIRS, setDocsSentToIRS] = useState(customerData.customerLeadData.leadStage?.leadStageId === '9222ce06-f740-467d-a86f-bc782a1d3887')
  const [docsReceivedAtIRS, setDocsReceivedAtIRS] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'e36b27ed-74f2-4733-83bc-a4d6bc5d0915')
  const [syncNewBankAccount, setSyncNewBankAccount] = useState(customerData.customerLeadData.leadStage?.leadStageId === '085830f0-9598-47ff-bf2c-d0b7bd4deabc')
  const [uploadID, setUploadID] = useState(customerData.customerLeadData.leadStage?.leadStageId === '54f7e7f4-6f4a-4a8f-95bb-414657a89404')
  const [issueResolved, setIssueResolved] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'd23bdf4e-886f-493a-b628-8c9a1efb398b')
  const [updateBanking, setUpdateBanking] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'c9d17db5-8581-441f-af7d-3dcc0caae173')
  const [signTOS, setSignTOS] = useState(customerData.customerLeadData.leadStage?.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91' && !customerData.customerTOSData.tosId)
  const [noFiledDate, setNoFiledDate] = useState(customerData.customerLeadData.leadStage?.leadStageId === '3b4e1465-5211-4ac0-a215-371db7a2dd37')
  const [pastDeadline, setPastDeadline] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'eb56d073-2fff-4055-82b3-c0939cff5815')
  const [manualIDReview, setManualIDReview] = useState(customerData.customerLeadData.leadStage?.leadStageId === '4fbbed3e-41d7-40e6-8e96-24f01e3925a4')
  const [uploadReviewID, setUploadReviewID] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'a8670a9f-cbd2-4d61-97f0-4008e9ff8e7b')
  const [pastAFDeadline, setPastAFDeadline] = useState(customerData.customerLeadData.leadStage?.leadStageId === 'f96797f5-64bd-443a-ad49-dc0abed71e07')
  const [showPostPaidDiscount, setShowPostPaidDiscount] = useState(shouldShowPostPaidDiscount())
  const [showMissplacedCheck, setShowMissplacedCheck] = useState(customerData.customerLeadData.leadStage?.leadStageId === '1ed8790d-d16d-492d-a244-38955b037f73')
  const [showPaymentInstallation] = useState(shouldShowPaymentInstallmentTile())
  const [showPaymentInstallmentStatus] = useState(shouldShowPaymentInstallmentStatus())
  const [showUpdateCardOnFile] = useState(shouldShowUpdateCardOnFileTile())
  const [show8822, setShow8822] = useState(customerData.customerLeadData.leadStage?.leadStageId === '534e19f0-70db-448b-9743-4437af68100d' || customerData.customerLeadData.leadStage?.leadStageId === 'f5dad279-d795-405c-ae58-daa61aa18473')
  const [showDemandLetter, setShowDemandLetter] = useState(customerData.customerDemandLetter && customerData.customerDemandLetter.pdfUrl ? true : false)
  const [hasTime, setHasTime] = useState(false)
  const [customerQRCode, setCustomerQRCode] = useState('')
  const [customerStageDetails, setCustomerStageDetails] = useState(customerData.getCustomerStageName())
  const [connectIDme, setConnectIDme] = useState(localStorage.getItem('idme'))
  const [turnkeyReauthNeedsAction, setTurnkeyReauthNeedsAction] = useState(false)
  const [needsWithdrawalAck, setNeedsWithdrawalAck] = useState(false)

  useEffect(() => {
    const checkWithdrawalAck = async () => {
      try {
        const leadId = customerData.customerLeadData.leadId
        if (!leadId) return
        const response = await fetch(`${apiURL}/api/getWithdrawal8821AckStatus?leadId=${encodeURIComponent(leadId)}`, {
          headers: { Authorization: customerData.accessToken }
        })
        const data = await response.json()
        if (data.response?.required)
          setNeedsWithdrawalAck(true)
      } catch (_) { /* non-blocking */ }
    }
    checkWithdrawalAck()
  }, [])

  useEffect(() => {
    const handleCheckInstantCalc = async () => {
      const checkInstantCalcResponse = await fetch(`${apiURL}/api/checkCanInstantCalc`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const checkInstantCalcData = await checkInstantCalcResponse.json()
      if (checkInstantCalcData.response.error) {
        if (checkInstantCalcData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheckInstantCalc() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkInstantCalcData.response.error)
      } else
        setCanInstantCalc(checkInstantCalcData.response.canRun)

      setCheckedInstantCalc(true)
    }

    const handleCheckAF = async () => {
      const checkInstantCalcResponse = await fetch(`${apiURL}/api/checkCanAF`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const checkInstantCalcData = await checkInstantCalcResponse.json()
      if (checkInstantCalcData.response.error) {
        if (checkInstantCalcData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheckInstantCalc() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkInstantCalcData.response.error)
      } else
        setCanAF(checkInstantCalcData.response.canRun)
    }

    handleCheckInstantCalc()
    handleCheckAF()
    setShowNavBar(true)
    document.title = `${company.companyName} | Stage History`
    if (currentActiveTab)
      setActiveTab(currentActiveTab)

    setShowWelcomeModal(customerData.customerCreatedAccount)
  }, [])

  const handleGetQRCode = async () => {
    const s3Response = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerQRCodeData.qrCodeURL)}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const s3Data = await s3Response.json()
    if (s3Data.response.error) {
      if (s3Data.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleGetQRCode() : navigate('/', { state: { expired: true } })
      } else
        console.error(s3Data.response.error)
    } else
      setCustomerQRCode(s3Data.response.s3Url)
  }

  useEffect(() => {
    handleGetQRCode()

    const filingDateStr = (customerData.customerLeadData.leadContact.filingDate ? customerData.customerLeadData.leadContact.filingDate : customerData.customerDocuments.filingDate) || '2022-04-18'
    const filingDate = DateTime.fromISO(filingDateStr, { zone: 'America/New_York' })
    const today = DateTime.now().setZone('America/New_York').startOf('day')

    let deadline

    if (filingDate < DateTime.fromISO('2022-04-18', { zone: 'America/New_York' })) {
      deadline = DateTime.fromISO('2025-04-18', { zone: 'America/New_York' })
    } else if (filingDate > DateTime.fromISO('2022-10-15', { zone: 'America/New_York' })) {
      deadline = DateTime.fromISO('2025-10-15', { zone: 'America/New_York' })
    } else {
      deadline = DateTime.fromObject(
        { year: 2025, month: filingDate.month, day: filingDate.day },
        { zone: 'America/New_York' }
      )
    }

    setHasTime(today <= deadline)
  }, [])

  useEffect(() => {
    const leadStageId = customerData.customerLeadData.leadStage?.leadStageId
    if (leadStageId !== REAUTH_TURNKEY_STAGE_ID) {
      setTurnkeyReauthNeedsAction(false)
      return
    }
    let cancelled = false
    ;(async () => {
      try {
        const fetchRedo = () => fetch(`${apiURL}/api/getReauthRedoSteps?leadId=${encodeURIComponent(customerData.customerLeadData.leadId)}`, {
          headers: { Authorization: customerData.accessToken }
        })
        let res = await fetchRedo()
        let data = await res.json()
        if (data.response?.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          if (refreshedToken && !cancelled) {
            res = await fetchRedo()
            data = await res.json()
          }
        }
        if (cancelled)
          return
        const r = data.response
        if (!r || r.error) {
          setTurnkeyReauthNeedsAction(false)
          return
        }
        const redo = !!(Number(r.redoStep1) || Number(r.redoStep2) || Number(r.redoStep3))
        const allDone = !!(Number(r.step1Completed) && Number(r.step2Completed) && Number(r.step3Completed))
        setTurnkeyReauthNeedsAction(redo || !allDone)
      } catch {
        if (!cancelled)
          setTurnkeyReauthNeedsAction(false)
      }
    })()
    return () => { cancelled = true }
  }, [])

  return (
    <>
      <div className='flex flex-row font-mont justify-center bg-slate-200 min-h-[calc(100vh-72px)]'>
        <div className='flex max-sm:flex-col flex-row flex-1 max-sm:items-center items-start font-mont max-w-[1250px] gap-10 lg:h-fit mt-4 mb-4'>
          <DashboardSidePanel
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className='flex flex-col items-center h-full w-full'>
            {customerData.customerLeadData.leadType === 'Leads' && (
              <DashboardProgress />
            )}
            <DashboardTopBar reauthTurnkeyNeedsAction={turnkeyReauthNeedsAction} />

            {needsWithdrawalAck && (
              <div className='w-full flex flex-col items-center gap-4 mt-4'>
                <div className='shadow-md p-4 rounded-xl w-full h-fit flex flex-col items-center bg-[#5186C0] font-mont text-white'>
                  <p className='font-bold text-2xl'>Withdrawal Acknowledgment Required</p>
                  <p className='text-center mt-2'>Please sign the Form 8821 Withdrawal Acknowledgment so we can complete your file with the IRS.</p>
                </div>
                <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
                  <button
                    onClick={() => navigate('/reauth/withdrawal-ack')}
                    className='px-6 py-3 bg-primaryColor text-white font-semibold rounded-lg shadow hover:bg-primaryDarkColor transition'
                  >
                    Sign Withdrawal Acknowledgment
                  </button>
                </div>
              </div>
            )}

            {showDemandLetter && (
              <DashboardDemandLetter />
            )}

            {(activeTab === 0 || activeTab === -1) && (
              (!invalid8821 && !isTaxStatus && !connectIDme && !customerData.customerLeadData.leadStage?.leadStageName.startsWith('AF') || (customerData.customerLeadData.leadStage?.leadStageName.startsWith('AF') && canAF) ? (
                <>
                  {isPreQualified && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardChartConnect setShowNavBar={setShowNavBar} />
                    </div>
                  )}
                  {shouldShowPayInvoiceButton() && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      <div className='shadow-md p-4 rounded-xl w-full h-fit flex flex-col items-center bg-[#5186C0] font-mont text-white'>
                        <p className='font-bold text-2xl'>Pay Invoice</p>
                        <p className='text-center mt-2'>Your service fee is ready. Please complete your payment to continue.</p>
                      </div>
                      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
                        <button onClick={() => navigate('/paymentPortal')} className='px-6 py-3 bg-primaryColor text-white font-semibold rounded-lg shadow hover:bg-primaryDarkColor transition'>
                          Pay Invoice
                        </button>
                        <p className='text-sm text-gray-400 text-center'>If your refund differs from the quoted amount, contact Customer Support for an adjustment.</p>
                      </div>
                    </div>
                  )}
                  {(shouldShowPostpaidStyleReauthorizeFlow(customerData.customerLeadData.leadStage?.leadStageId) || (customerData.customerLeadData.leadStage?.leadStageId === REAUTH_TURNKEY_STAGE_ID && turnkeyReauthNeedsAction)) && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      <div className='shadow-md p-4 rounded-xl w-full h-fit flex flex-col items-center bg-[#5186C0] font-mont text-white'>
                        <p className='font-bold text-2xl'>Reauthorize Your Account</p>
                        <p className='text-center mt-2'>To continue processing your refund, please complete the verification steps below.</p>
                      </div>
                      <DashboardReauthFlow />
                    </div>
                  )}
                  {(isChartInstantCalc && canInstantCalc) && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardChartInstantCalculation
                        setIsChartInstantCalc={setIsChartInstantCalc}
                        setCheckForCalculation={setCheckForCalculation}
                      />
                    </div>
                  )}
                  {(!canInstantCalc && checkedInstantCalc) && !shouldShowDealCompletePartialPayInvoice() && (
                    <DashboardInstantOffline />
                  )}
                  {isPendingCalc && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardPendingCals />
                    </div>
                  )}
                  {hasRefund && (
                    hasTime ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <RefundCalculatedWindow />
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardPastDeadline />
                      </div>
                    )

                  )}
                  {isPendingBank && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardPendingBank />
                    </div>
                  )}
                  {failedBankValidation && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardFailedBankValidation />
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  )}
                  {(failedToCreateBankApplication && !customerData.customerVerificationData.customerId) && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardResyncIDME />
                    </div>
                  )}
                  {bankValidated && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardBankVerified />
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  )}
                  {hasDocuments && (
                    customerData.customerLeadData.leadStage?.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9' ? (
                      customerData.customerVerificationData.customerId ? (
                        <div className='w-full flex flex-col items-center gap-4 mt-4'>
                          <div className='max-sm:w-11/12 shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
                            <p className='font-bold text-2xl text-[#646464]'>UPS Store QR Code</p>
                            <img className='w-44' src={customerQRCode} />
                          </div>
                          <DashboardDocumentsHeader />
                          <div className='w-full flex flex-col gap-3'>
                            {!isDocumentsAvailablePrepaidStage() && (
                              <button onClick={() => navigate('/paymentPortal')} className='w-full px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
                                Pay Invoice
                              </button>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className='w-full flex flex-col items-center gap-4 mt-4'>
                          <DashboardResyncIDME />
                        </div>
                      )
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        <DashboardDocumentsHeader />
                        <div className='w-full flex flex-col gap-3'>
                          {!isDocumentsAvailablePrepaidStage() && (
                            <button onClick={() => navigate('/paymentPortal')} className='w-full px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
                              Pay Invoice
                            </button>
                          )}
                          {(shouldShowPostpaidStyleReauthorizeFlow(customerData.customerLeadData.leadStage?.leadStageId) || (customerData.customerLeadData.leadStage?.leadStageId === REAUTH_TURNKEY_STAGE_ID && turnkeyReauthNeedsAction)) && (
                            <button onClick={() => navigate('/reauth/id-verification')} className='w-full px-6 py-3 bg-[#5186C0] text-white font-semibold rounded-lg shadow hover:bg-[#4070A0] transition'>
                              Reauthorize Account
                            </button>
                          )}
                        </div>
                      </div>
                    )
                  )}
                  {docsMailed && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardDocsSentToOffice />
                    </div>
                  )}
                  {docsReceived && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardDocsSentToOffice />
                    </div>
                  )}
                  {issueWithDocs && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardIssueWithDocs />
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  )}
                  {canESign && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardESign />
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  )}
                  {docsSentToIRS && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardDocsSentToIRS />
                    </div>
                  )}
                  {docsReceivedAtIRS && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardDocsReceivedAtIRS />
                    </div>
                  )}
                  {inReview && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardInReview />
                    </div>
                  )}
                  {showMissplacedCheck && (
                    <DashboardMissplacedCheck />
                  )}

                  {showPaymentInstallmentStatus && (
                    <DashboardPaymentInstallments />
                  )}
                  {showPaymentInstallation && (
                    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-6 mt-4'>
                      <p className='font-bold text-2xl'>Payment Installments</p>
                      <p className='text-lg text-left'>To support you, we are offering a convenient payment plan option. This program allows you to resolve your balance through <span className='font-bold'>affordable weekly or monthly installments</span> while avoiding any further action that could negatively impact your credit. We're here to work with you and make the process as simple as possible.</p>
                      <button onClick={() => navigate('/payment-installations')} className='px-6 py-3 bg-primaryColor text-white font-semibold rounded-lg shadow hover:bg-primaryDarkColor transition'>
                        Set Up Installments
                      </button>
                      <p className='text-sm text-gray-400 mt-2 text-center'>Thank you for your prompt attention.</p>
                    </div>
                  )}
                  {showUpdateCardOnFile && !showPaymentInstallmentStatus && (
                    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4 mt-4'>
                      <p className='font-bold text-2xl text-center'>Update card on file</p>
                      <p className='text-lg text-center text-gray-700'>
                        Replace the card we keep on file for your account. No payment is processed — this only updates your saved card for future charges.
                      </p>
                      <button
                        type='button'
                        onClick={() => navigate('/update-card-on-file')}
                        className='px-6 py-3 bg-white border-2 border-primaryColor text-primaryColor font-semibold rounded-lg shadow hover:bg-slate-50 transition'
                      >
                        Update card
                      </button>
                    </div>
                  )}
                  {isCollections && (
                    <CollectionsWindow />
                  )}
                  {resetAgreement && (
                    <DashboardResetAgreement />
                  )}
                  {resign && (
                    customerData.customerVerificationData.customerId ? (
                      <DashboardResign />
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  )}
                  {signAffidavit && (
                    customerData.customerVerificationData.customerId ? (
                      <DashboardSignAffidavit />
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                          </div>
                        )}
                        <DashboardResyncIDME />
                      </div>
                    )
                  )}
                  {syncNewBankAccount && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>IDme Reconnect</p>
                        </div>
                      )}
                      <DashboardSyncBankAccount />
                    </div>
                  )}
                  {uploadID && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardUploadReviewID
                          setUploadReviewID={setUploadReviewID}
                          setManualIDReview={setManualIDReview}
                        />
                      </div>
                    ) : (
                      <DashboardResyncIDME />
                    )
                  )}
                  {issueResolved && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>Issue Resolved</p>
                        </div>
                      )}
                      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
                        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
                        <p className='font-bold text-xl text-[#646464] text-center'>Our team is working to confirm that your issue has been resolved and are ready to continue your application.</p>
                      </div>
                    </div>
                  )}
                  {updateBanking && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>Update Banking</p>
                        </div>
                      )}
                      <DashboardUpdateBanking setShowNavBar={setShowNavBar} />
                    </div>
                  )}
                  {signTOS && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className='text-[#FF8C00] text-center font-bold text-3xl'>Sign TOS</p>
                        </div>
                      )}
                      <DashboardSignTOS />
                    </div>
                  )}
                  {noFiledDate && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardDocumentsHeader />
                    </div>
                  )}
                  {pastDeadline && (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardPastDeadline />
                    </div>
                  )}
                  {pastAFDeadline && (
                    !hasTime ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardPastDeadline />
                      </div>
                    ) : (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <RefundCalculatedWindow />
                      </div>
                    )
                  )}
                  {manualIDReview && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardManualIDReview />
                      </div>
                    ) : (
                      <DashboardResyncIDME />
                    )
                  )}
                  {uploadReviewID && (
                    customerData.customerVerificationData.customerId ? (
                      <div className='w-full flex flex-col items-center gap-4 mt-4'>
                        {window.innerWidth <= 768 && (
                          <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                            <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                          </div>
                        )}
                        <DashboardUploadReviewID
                          setUploadReviewID={setUploadReviewID}
                          setManualIDReview={setManualIDReview}
                        />
                      </div>
                    ) : (
                      <DashboardResyncIDME />
                    )
                  )}

                  {show8822 && (
                    <Send8822 />
                  )}
                </>
              ) : (
                invalid8821 ? (
                  <div className='w-full flex flex-col items-center gap-4 mt-4'>
                    {window.innerWidth <= 768 && (
                      <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                        <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                        <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                      </div>
                    )}
                    <DashboardReconnectChart setShowNavBar={setShowNavBar} />
                  </div>
                ) : connectIDme ? (
                  !connectIDme ? (
                    <div className='w-full flex flex-col items-center gap-4 mt-4'>
                      {window.innerWidth <= 768 && (
                        <div className='shadow-full rounded-xl p-4 max-sm:w-11/12 w-[32%] bg-white flex flex-col'>
                          <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
                          <p className={`text-[${customerStageDetails.color}] text-center font-bold text-3xl`}>{customerStageDetails.text}</p>
                        </div>
                      )}
                      <DashboardChartConnect setShowNavBar={setShowNavBar} />
                    </div>
                  ) : (
                    <DashboardCompleteIDme />
                  )
                ) : (
                  <div className='lg:w-full w-11/12 flex flex-col gap-4 mt-4'>
                    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
                      <div className='w-full flex flex-col items-center'>
                        <div className='w-full flex flex-col items-center gap-4'>
                          <p className='font-bold text-2xl'>Maintenance</p>
                          <p>We are undergoing some maintenance, and will be back up in no time!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              ))
            )}
            {activeTab !== -1 && (
              <DashboardHeader
                activeTab={activeTab}
              />
            )}
            {activeTab === 0 ? (
              <DashboardStageHistory />
            ) : activeTab === 1 ? (
              <DashboardDocumentsCenter />
            ) : activeTab === 2 ? (
              <DashboardResourceCenter />
            ) : activeTab === 3 ? (
              <DashboardQA />
            ) : activeTab === 4 ? (
              <DashboardContactUs />
            ) : activeTab === 5 ? (
              <DashboardReferAFriend />
            ) : activeTab === 6 ? (
              <DashboardChangeDays />
            ) : activeTab === 7 ? (
              <DashboardDiscountCode />
            ) : (
              <></>
            )}
          </div>
        </div>
        <MobileSideBar showMobileSideBar={showMobileSideBar} setShowMobileSideBar={setShowMobileSideBar} activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      {showWelcomeModal && (
        <WelcomeModal setShowWelcomeModal={setShowWelcomeModal} />
      )}
    </>
  )
}

/**
 * {customerData.customerLeadData.leadStage?.leadStageId === '5b976e6e-2565-47bd-b944-f929caf2d583' && (
                  <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-6 mt-4'>
                    <p className='font-bold text-2xl text-[#646464]'>Action Required: Update Your IRS Transcript Immediately</p>
                    <p className='text-[#646464] text-lg text-left'>Click the button labeled "Connect with Chart" to Protect & Track Your Refund  This steps protects your identity and enables us to securely monitor your IRS tax transcript. By doing so, we can confirm that your refund is correctly processed and sent directly to you - either by check or ACH deposit into your bank account.</p>
                    <p className='text-[#646464] text-lg text-left'>Your tax refund is never routed to us. It always goes directly to you.</p>
                    <button onClick={() => navigate('/reauth-flow')} className='px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
                      Connect with Chart
                    </button>
                    <p className='text-sm text-gray-400 mt-2 text-center'>Thank you for your prompt attention.</p>
                  </div>
                )}

                {customerData.customerLeadData.leadStage?.leadStageId === 'a655adeb-b27f-4ba6-b1cc-b4944515b554' && (
                    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-6 mt-4'>
                      <p className='font-bold text-2xl text-[#646464]'>Action Required: Update Your IRS Transcript Immediately</p>
                      <p className='text-[#646464] text-lg text-left'>Click the button labeled "Connect with Chart" to Protect & Track Your Refund  This steps protects your identity and enables us to securely monitor your IRS tax transcript. By doing so, we can confirm that your refund is correctly processed and sent directly to you - either by check or ACH deposit into your bank account.</p>
                      <p className='text-[#646464] text-lg text-left'>Your tax refund is never routed to us. It always goes directly to you.</p>
                      <button onClick={() => navigate('/reauth-flow')} className='px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
                        Connect with Chart
                      </button>
                      <p className='text-sm text-gray-400 mt-2 text-center'>Thank you for your prompt attention.</p>
                    </div>
                  )}


                
 */